import React, { useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import { TableUtility } from '@utility/dynamic-table';
import 'primeicons/primeicons.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';

const EMPTY_DATA = [];
const FIELDS = [
  ['employeeId', 'Employee ID'],
  ['name', 'Employee Name'],
  ['email', 'Employee Email'],
];

const EmployeePermissionFilters = ({ employees, employee, onChange }) => {
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;
  const configuration = useMemo(() => ({
    generalSettings: {
      baseURL: '',
      enableApiFiltering: false,
      showToolBar: true,
      showPagination: false,
      handler: {
        onFilterUpdate: ({ action, filters = [] }) => {
          const selectedFilter = ['employeeId', 'name', 'email']
            .map((field) => filters.find((filter) => filter.field === field))
            .find((filter) => filter?.selectedValues?.length
              || (filter?.selectedValue !== undefined && filter?.selectedValue !== null
                && filter?.selectedValue !== ''));
          const selection = action === 'reset' ? null
            : selectedFilter?.selectedValues?.[0] ?? selectedFilter?.selectedValue;
          const selectedId = selection?.value ?? selection?.id ?? selection;
          onChangeRef.current(employees.find((item) => item.id === selectedId) || null);
        },
      },
      toolBarSettings: {
        showColumnFilterMenu: true,
        showAddNew: false,
        showSearch: false,
        showDownloadExcel: false,
        showDownloadCsv: false,
        showColumnCustomize: false,
        showHelp: false,
        showSaveView: false,
        showReset: false,
        showExpandCollapse: false,
      },
    },
    tableSettings: {
      tableScrollHeight: '1px',
      maxFrozenColumns: { desktop: 0, tablet: 0, mobile: 0 },
      tableConfig: FIELDS.map(([field, header]) => ({
        field,
        header,
        visible: true,
        isGlobalFilter: true,
        menuItems: [{
          label: header,
          items: [{
            type: 'filter',
            template: 'singleSelect',
            field,
            label: header,
            multifilteroptionselect: true,
            options: employees.map((item) => ({
              value: item.id,
              label: field === 'name' ? `${item.name} (${item.employeeId})` : item[field],
            })),
            selectedValues: employee ? [employee.id] : [],
            selectedValue: employee?.id ?? null,
            selectedLabel: employee?.[field] || '',
          }],
        }],
      })),
    },
  }), [employees, employee]);

  return (
    <div className="permission-table-filters">
      <TableUtility
        key={employee?.id || 'no-employee'}
        configuration={configuration}
        data={EMPTY_DATA}
        emptyStateComponent={<></>}
        showFilterOption
      />
    </div>
  );
};

EmployeePermissionFilters.propTypes = {
  employees: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    employeeId: PropTypes.string,
    name: PropTypes.string,
    email: PropTypes.string,
  })).isRequired,
  employee: PropTypes.shape({ id: PropTypes.string }),
  onChange: PropTypes.func.isRequired,
};

EmployeePermissionFilters.defaultProps = { employee: null };

export default EmployeePermissionFilters;
